/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { idTokenSelector } from "../../store/api/auth/selectors";
import { ROUTES } from "../../globals/globals";

const RequireAuth = () => {
  const token = useSelector(idTokenSelector);
  const location = useLocation();

  return (
    token
      ? < Outlet />
      : <Navigate to={ROUTES.LOGIN.Path} state={{ from: location }} replace />
  );
};

export default RequireAuth;
